import { ChangeDetectionStrategy, Component, ElementRef, OnInit, Input, Output, EventEmitter, ViewChild } from '@angular/core';

@Component({
	selector: 'category-nav',
	templateUrl: './category-nav.component.html',
	styleUrls: ['./category-nav.component.scss'],
	changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CategoryNavComponent implements OnInit {
	@Input() itemsToHide;
	@Input() categories;
	@Input() comboCategoryName = 'Combos';
	@Input() pizzaCategoryName = 'Pizzas';
	@Input() stickyMode = false;

	@Input() isNewHomePedirDelivery = false;
	@Input() set activeCategoryValue(value: string) {
		if (value == null || value === '' || value === this.categoryToScroll) return;
		this.categoryToScroll = value;
		setTimeout(() => this.scrollActivePillIntoView(), 50);
	}

	@ViewChild('pillsWrapper') pillsWrapper: ElementRef<HTMLElement>;

	categoryToScroll: string = '';
	categoryToCentralizeInNav: string;
	selectedCategory: any;
	selectId = 'categoryNav';

	@Output() scrollToCategory = new EventEmitter<string>();

	constructor() { }

	ngOnInit() {
		if (this.categoryToScroll) return;

		if (this.itemsToHide && !this.itemsToHide.featuredItems) { this.categoryToScroll = 'featuredItems'; return; }
		if (this.itemsToHide && !this.itemsToHide.combos) { this.categoryToScroll = 'combos'; return; }
		if (this.itemsToHide && !this.itemsToHide.pizzas) { this.categoryToScroll = 'pizzas'; return; }
		if (this.categories?.length) this.categoryToScroll = this.categories[0].name + '-' + this.categories[0].id;
	}

	selectCategory(value: string) {
		this.categoryToScroll = value;
		this.scrollToCategory.emit(value);
	}

	scrollActivePillIntoView() {
		if (this.stickyMode || !this.pillsWrapper?.nativeElement) return;
		const active = this.pillsWrapper.nativeElement.querySelector('.category-pill--active') as HTMLElement;
		if (active) active.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'center' });
	}

	onSelectChange(ev: Event) {
		const value = (ev.target as HTMLSelectElement).value;
		this.categoryToScroll = value;
		this.scrollToCategory.emit(value);
	}

	changeCategory(ev: any) {
		const value = ev?.detail?.value;
		if (value != null) {
			this.categoryToScroll = value;
			this.scrollToCategory.emit(value);
		}
	}

	trackById(_index: number, category: any) {
		return category ? category.id : _index;
	}

	truncate(text: string, maxLength = 35): string {
		const isMobile = window.innerWidth < 768;
		maxLength = isMobile ? 30 : 60;
		if (!text || text.length <= maxLength) return text;
		return text.slice(0, maxLength).replace(/\s+$/, '') + '…';
	}

	showCategory(items) {
		// if(category.isSelfService) return false;

		// const items = category.products;

		if(!items) return false;

		return items.some(item => !item.unavailable && !item.unavailableByTemplate && item.totalCalcType !== 'WEIGHT');
	}

}
